'use client';

import { Flex, freddyTheme, Link, List, ListItem, Typography } from '@coolblue-development/freddy';
import { ArrowRight } from '@coolblue-development/icons';
import { useTranslation } from '@i18n/useTranslation';

export default function ProductCondition({
  productConditions,
  description
}: {
  productConditions: string[];
  description: string | null;
}) {
  const { t } = useTranslation('webshop.secondChance');
  const productDescription = description
    ? description
        .split(' - ')
        .map(s => s.trim())
        .filter(Boolean)
    : [];

  return (
    <Flex gap={200} direction='column'>
      <Typography variant='h3'>{t('secondChanceProductCondition')}</Typography>
      <List columns={{ xs: 1, md: 2 }} sx={{ columnGap: freddyTheme.spacing[500] }}>
        {productConditions?.map(condition => {
          return <ListItem key={condition}>{condition}</ListItem>;
        })}
        {productDescription.map((condition, index) => {
          if (index === 0) return null;
          return <ListItem key={condition}>{condition}</ListItem>;
        })}
      </List>
      {/* TODO: Open Modal onClick */}
      <Link startIcon={<ArrowRight />}> {t('learnMore')}</Link>
    </Flex>
  );
}
